import { fetcherWithToken } from '@/shared/api/fetcher';
import useSWRMutation from 'swr/mutation';
export function useWishlist() {
  const { trigger } = useSWRMutation('/setFavorite', (url, { arg }) => {
    const params = new URLSearchParams(arg);
    return fetcherWithToken(`${url}?${params}`, {
      method: 'GET',
    });
  });
  return {
    trigger,
  };
}
